import { Component, Input, OnInit } from '@angular/core'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { UserService } from 'src/app/services/user/user.service'
import { LoginInstallChoiceModalComponent } from '../login-install-choice-modal/login-install-choice-modal.component'

@Component({
  selector: 'app-app-ad-modal',
  templateUrl: './app-ad-modal.component.html',
  styleUrls: ['./app-ad-modal.component.scss'],
})
export class AppAdModalComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private localeService: LocaleService,
    private userService: UserService
  ) {}

  @Input() isHost: boolean = false
  isKo = this.localeService.isKo
  isLoggedIn = this.userService.isLoggedIn

  ngOnInit() {}

  async onClickInstallApp(): Promise<void> {
    if (this.isHost && !this.isLoggedIn) {
      const loginChoiceModal = await this.modalService.openBottomSheet(LoginInstallChoiceModalComponent, {
        logOnClickLogin: () => {},
        logOnClickInstall: () => {},
      })
      await loginChoiceModal.present()
    }
  }

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onOpenAppSucceed(): void {
    this.modalService.dismiss()
  }
}
